module.exports = __webpack_public_path__ + "img/initial.82502bec.png";